function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.343 7.139L2.178 1.656H0v12.413h2.392v-8.16l3.867 4.861h.133l3.9-4.9v8.2h2.392V1.656h-2.176L6.343 7.139z",
  fill: "#364045"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path",
  d: "M47.83 14.068h2.351V.939l-2.351.716v12.413zM43.454 14.068h2.351V.939l-2.351.716v12.413z",
  fill: "#364045"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.102 14.279a4.546 4.546 0 01-3.056-.957 4.631 4.631 0 01-1.352-3.684 5.164 5.164 0 011.438-4.048 4.272 4.272 0 012.848-.967 5.856 5.856 0 011.449.182l.171.045V1.659l2.322-.642v12.488l-.061.023a10.882 10.882 0 01-3.76.751zm.308-7.589c-1.392 0-2.223 1.052-2.223 2.814a2.843 2.843 0 00.847 2.369 2.092 2.092 0 001.2.379h.188a3.9 3.9 0 001.08-.181l.093-.031V6.932l-.089-.033a3.177 3.177 0 00-1.1-.208z",
  fill: "#364045"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path",
  d: "M52.167 14.069h2.351V4.504l-2.351.716v8.849z",
  fill: "#364045"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path",
  d: "M51.763 1.662l1.686 1.715 1.686-1.688L53.449 0l-1.686 1.662z",
  fill: "#4050c6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M36.522 14.27a3.477 3.477 0 01-2.266-.792 2.763 2.763 0 01-.982-2.166 2.61 2.61 0 011.073-2.185 5.2 5.2 0 013.084-.811 7.2 7.2 0 011.582.18 2.185 2.185 0 00-.311-1.421 2.1 2.1 0 00-1.593-.5h-.025a6.681 6.681 0 00-2.791.621h-.019V5.269a6.635 6.635 0 012.905-.673h.038c1.816 0 4.229.377 4.229 3.638v5.8h-2.254v-.508a4.688 4.688 0 01-2.67.744zm1.225-4.374h-.121c-.954 0-1.973.363-1.973 1.381a1.237 1.237 0 001.401 1.259 2.541 2.541 0 001.986-.758v-1.751a6.662 6.662 0 00-1.293-.131zM59.027 14.27a3.476 3.476 0 01-2.265-.792 2.763 2.763 0 01-.982-2.166 2.61 2.61 0 011.073-2.185 5.2 5.2 0 013.084-.811 7.211 7.211 0 011.583.18 2.193 2.193 0 00-.312-1.421 2.1 2.1 0 00-1.593-.5h-.025a6.681 6.681 0 00-2.791.621h-.019V5.269a6.635 6.635 0 012.905-.673h.038c1.816 0 4.229.377 4.229 3.638v5.8h-2.254v-.508a4.689 4.689 0 01-2.671.744zm1.225-4.374h-.121c-.954 0-1.973.363-1.973 1.381a1.236 1.236 0 001.4 1.253 2.541 2.541 0 001.986-.758v-1.745a6.662 6.662 0 00-1.292-.131zM18.803 14.304c-1.395 0-4.64-.468-4.64-4.817a4.845 4.845 0 011.494-3.856 4.471 4.471 0 012.847-1.027h.043a3.936 3.936 0 012.765 1.023 4.872 4.872 0 011.215 3.677c0 .4-.032.979-.032.985h-5.983a2.413 2.413 0 00.353.91 2.786 2.786 0 002.322 1.163 5.463 5.463 0 002.736-.739v1.964a8.006 8.006 0 01-3.12.717zm-.309-7.746a1.973 1.973 0 00-1.738 1.038 2.245 2.245 0 00-.227 1.008h3.9a2.413 2.413 0 00-.183-1 1.8 1.8 0 00-1.629-1.047h-.074z",
  fill: "#364045"
});

function SvgMedalliaLogoPoweredBy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Medallia logo color Copy 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.952 14.305"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgMedalliaLogoPoweredBy;